export const industryTranslations = {
  en: {
    services: {
      video: "Video Production",
      photography: "Photography",
      social: "Social Media Content",
      print: "Print Materials",
      website: "Website Solutions",
    },
    industries: {
      restaurants: {
        title: "Restaurants & Cafes",
        video: [
          "Food plating videos",
          "Customer testimonials",
          "Ambiance videos",
          "Chef interviews",
          "Behind-the-scenes kitchen tours",
          "Menu item spotlights",
          "How-to cooking videos",
        ],
        photography: [
          "High-quality food photography",
          "Interior/exterior shots",
          "Staff photos",
          "Event photography",
        ],
        social: [
          "Engaging posts with food visuals",
          "Daily specials",
          "Customer contests",
          "Influencer collaborations",
        ],
        print: [
          "Menus",
          "Flyers",
          "Table tents",
          "Loyalty cards",
          "Business cards",
        ],
        website: [
          "Online ordering system",
          "Reservations",
          "Food delivery partnerships",
        ],
      },
      retail: {
        title: "Retail Stores",
        video: [
          "Product demos",
          "Customer testimonials",
          "Unboxing videos",
          "Store tours",
          "Seasonal promotions",
          "Influencer collaborations",
        ],
        photography: [
          "High-quality product photography",
          "Lifestyle shots",
          "Store interior/exterior shots",
          "Model shots",
        ],
        social: [
          "Product launches",
          "Sales announcements",
          "Behind-the-scenes",
          "Customer spotlights",
          "Influencer marketing",
        ],
        print: [
          "Brochures",
          "Flyers",
          "Window displays",
          "In-store signage",
          "Price tags",
          "Business cards",
        ],
        website: ["E-commerce platform", "Online catalogs", "Customer reviews"],
      },
      salons: {
        title: "Salons & Spas",
        video: [
          "Treatment demonstrations",
          "Client testimonials",
          "Spa tours",
          "Before-and-after transformations",
          "Staff introductions",
        ],
        photography: [
          "High-quality service images",
          "Staff photos",
          "Spa ambiance",
          "Client portraits",
        ],
        social: [
          "Treatment specials",
          "Promotions",
          "Staff spotlights",
          "Client transformations",
        ],
        print: [
          "Service menus",
          "Gift certificates",
          "Business cards",
          "Promotional materials",
        ],
        website: ["Online booking", "Service descriptions", "Staff profiles"],
      },
      fitness: {
        title: "Fitness Centers & Gyms",
        video: [
          "Workout tutorials",
          "Member success stories",
          "Facility tours",
          "Class previews",
          "Trainer introductions",
        ],
        photography: [
          "Facility photos",
          "Class action shots",
          "Equipment demonstrations",
          "Member transformations",
        ],
        social: [
          "Workout tips",
          "Nutrition advice",
          "Member spotlights",
          "Class schedules",
          "Special events",
        ],
        print: [
          "Class schedules",
          "Membership brochures",
          "Business cards",
          "Promotional flyers",
        ],
        website: [
          "Class booking system",
          "Membership options",
          "Trainer profiles",
        ],
      },
      realestate: {
        title: "Real Estate Agencies",
        video: [
          "Property tours",
          "Area guides",
          "Agent introductions",
          "Client testimonials",
          "Market updates",
        ],
        photography: [
          "Professional property photos",
          "Aerial photography",
          "Agent headshots",
          "Community features",
        ],
        social: [
          "Property listings",
          "Open house announcements",
          "Market insights",
          "Client success stories",
        ],
        print: [
          "Property brochures",
          "Business cards",
          "Direct mail materials",
          "Property flyers",
        ],
        website: [
          "Property listings",
          "Virtual tours",
          "Agent profiles",
          "Client testimonials",
        ],
      },
      professional: {
        title: "Professional Services",
        video: [
          "Client testimonials",
          "Service explanations",
          "Company culture videos",
          "Expert interviews",
          "Process demonstrations",
        ],
        photography: [
          "Professional headshots",
          "Office environment",
          "Team photos",
          "Event coverage",
        ],
        social: [
          "Industry insights",
          "Company updates",
          "Team spotlights",
          "Client success stories",
        ],
        print: [
          "Service brochures",
          "Business cards",
          "Presentation folders",
          "Case study documents",
        ],
        website: [
          "Service descriptions",
          "Team profiles",
          "Client portal",
          "Case studies",
        ],
      },
      homeservices: {
        title: "Home Services",
        video: [
          "Service demonstrations",
          "Client testimonials",
          "Before-and-after transformations",
          "Team introductions",
          "Safety procedures",
        ],
        photography: [
          "Before/after photos",
          "Team photos",
          "Equipment/tools",
          "Service process shots",
        ],
        social: [
          "Maintenance tips",
          "Seasonal services",
          "Customer reviews",
          "Special offers",
        ],
        print: [
          "Service brochures",
          "Business cards",
          "Estimate forms",
          "Door hangers",
        ],
        website: [
          "Service descriptions",
          "Online booking",
          "Service areas",
          "Emergency services",
        ],
      },
      ecommerce: {
        title: "E-commerce Businesses",
        video: [
          "Product demonstrations",
          "Unboxing experiences",
          "Customer testimonials",
          "Behind-the-scenes",
          "Product launches",
        ],
        photography: [
          "Product photography",
          "Lifestyle shots",
          "Package/unboxing",
          "360-degree views",
        ],
        social: [
          "Product features",
          "Customer reviews",
          "Special promotions",
          "How-to guides",
        ],
        print: [
          "Product catalogs",
          "Packaging design",
          "Insert cards",
          "Promotional materials",
        ],
        website: [
          "E-commerce platform",
          "Product pages",
          "Shopping cart",
          "Customer reviews",
        ],
      },
    },
  },
  de: {
    services: {
      video: "Videoproduktion",
      photography: "Fotografie",
      social: "Social Media Inhalte",
      print: "Druckmaterialien",
      website: "Website-Lösungen",
    },
    industries: {
      restaurants: {
        title: "Restaurants & Cafés",
        video: [
          "Videos zur Essenpräsentation",
          "Kundenbewertungen",
          "Ambiente-Videos",
          "Koch-Interviews",
          "Blick hinter die Kulissen der Küche",
          "Menüpunkt-Highlights",
          "Koch-Tutorial-Videos",
        ],
        photography: [
          "Hochwertige Foodfotografie",
          "Innen-/Außenaufnahmen",
          "Mitarbeiterfotos",
          "Event-Fotografie",
        ],
        social: [
          "Ansprechende Posts mit Essensbildern",
          "Tagesangebote",
          "Kundengewinnspiele",
          "Influencer-Kooperationen",
        ],
        print: [
          "Speisekarten",
          "Flyer",
          "Tischaufsteller",
          "Treuekarten",
          "Visitenkarten",
        ],
        website: [
          "Online-Bestellsystem",
          "Reservierungen",
          "Essenslieferungs-Partnerschaften",
        ],
      },
      retail: {
        title: "Einzelhandel",
        video: [
          "Produktdemonstrationen",
          "Kundenbewertungen",
          "Unboxing-Videos",
          "Ladenführungen",
          "Saisonale Werbeaktionen",
          "Influencer-Kooperationen",
        ],
        photography: [
          "Hochwertige Produktfotografie",
          "Lifestyle-Aufnahmen",
          "Laden Innen-/Außenaufnahmen",
          "Model-Aufnahmen",
        ],
        social: [
          "Produkteinführungen",
          "Verkaufsankündigungen",
          "Blick hinter die Kulissen",
          "Kundenspotlights",
          "Influencer-Marketing",
        ],
        print: [
          "Broschüren",
          "Flyer",
          "Schaufenstergestaltung",
          "Ladenbeschilderung",
          "Preisschilder",
          "Visitenkarten",
        ],
        website: [
          "E-Commerce-Plattform",
          "Online-Kataloge",
          "Kundenbewertungen",
        ],
      },
      salons: {
        title: "Salons & Spas",
        video: [
          "Behandlungsdemonstrationen",
          "Kundenbewertungen",
          "Spa-Führungen",
          "Vorher-Nachher-Transformationen",
          "Mitarbeitervorstellungen",
        ],
        photography: [
          "Hochwertige Aufnahmen der Dienste",
          "Mitarbeiterfotos",
          "Spa-Ambiente",
          "Kundenporträts",
        ],
        social: [
          "Behandlungsangebote",
          "Werbeaktionen",
          "Mitarbeiter-Spotlights",
          "Kundentransformationen",
        ],
        print: [
          "Servicemenüs",
          "Geschenkgutscheine",
          "Visitenkarten",
          "Werbematerialien",
        ],
        website: [
          "Online-Buchung",
          "Servicebeschreibungen",
          "Mitarbeiterprofile",
        ],
      },
      fitness: {
        title: "Fitnesscenter & Studios",
        video: [
          "Workout-Tutorials",
          "Erfolgsgeschichten der Mitglieder",
          "Einrichtungsführungen",
          "Kursvorschauen",
          "Trainer-Vorstellungen",
        ],
        photography: [
          "Einrichtungsfotos",
          "Kurs-Action-Aufnahmen",
          "Gerätevorführungen",
          "Mitgliedertransformationen",
        ],
        social: [
          "Workout-Tipps",
          "Ernährungsberatung",
          "Mitglieder-Spotlights",
          "Kurspläne",
          "Spezielle Events",
        ],
        print: [
          "Kurspläne",
          "Mitgliedschaftsbroschüren",
          "Visitenkarten",
          "Werbeflyer",
        ],
        website: [
          "Kursbuchungssystem",
          "Mitgliedschaftsoptionen",
          "Trainer-Profile",
        ],
      },
      realestate: {
        title: "Immobilienmakler",
        video: [
          "Immobilienbesichtigungen",
          "Gebietsführungen",
          "Maklervorstellungen",
          "Kundenbewertungen",
          "Marktaktualisierungen",
        ],
        photography: [
          "Professionelle Immobilienfotos",
          "Luftaufnahmen",
          "Makler-Portraits",
          "Umgebungsaufnahmen",
        ],
        social: [
          "Immobilienangebote",
          "Open-House-Ankündigungen",
          "Markteinblicke",
          "Kundenerfolgsstories",
        ],
        print: [
          "Immobilienexposés",
          "Visitenkarten",
          "Direktwerbung",
          "Immobilienflyer",
        ],
        website: [
          "Immobilienlistings",
          "Virtuelle Touren",
          "Maklerprofile",
          "Kundenbewertungen",
        ],
      },
      professional: {
        title: "Professionelle Dienste",
        video: [
          "Kundenreferenzen",
          "Serviceerklärungen",
          "Unternehmenskultur-Videos",
          "Experteninterviews",
          "Prozessvorführungen",
        ],
        photography: [
          "Professionelle Portraits",
          "Büroumgebung",
          "Teamfotos",
          "Eventdokumentation",
        ],
        social: [
          "Brancheneinblicke",
          "Unternehmens-Updates",
          "Team-Spotlights",
          "Kundenerfolgsstories",
        ],
        print: [
          "Servicebroschüren",
          "Visitenkarten",
          "Präsentationsmappen",
          "Fallstudien-Dokumente",
        ],
        website: [
          "Servicebeschreibungen",
          "Team-Profile",
          "Kundenportal",
          "Fallstudien",
        ],
      },
      homeservices: {
        title: "HaushaltsDienste",
        video: [
          "Service-Demonstrationen",
          "Kundenreferenzen",
          "Vorher-Nachher-Transformationen",
          "Team-Vorstellungen",
          "Sicherheitsverfahren",
        ],
        photography: [
          "Vorher/Nachher-Fotos",
          "Teamfotos",
          "Ausrüstung/Werkzeuge",
          "Service-Prozess-Aufnahmen",
        ],
        social: [
          "Wartungstipps",
          "Saisonale Dienste",
          "Kundenbewertungen",
          "Sonderangebote",
        ],
        print: [
          "Servicebroschüren",
          "Visitenkarten",
          "Angebotsformulare",
          "Türhänger",
        ],
        website: [
          "Servicebeschreibungen",
          "Online-Buchung",
          "Servicegebiete",
          "Notfalldienste",
        ],
      },
      ecommerce: {
        title: "E-Commerce Unternehmen",
        video: [
          "Produktdemonstrationen",
          "Unboxing-Erlebnisse",
          "Kundenbewertungen",
          "Blick hinter die Kulissen",
          "Produkteinführungen",
        ],
        photography: [
          "Produktfotografie",
          "Lifestyle-Aufnahmen",
          "Verpackung/Unboxing",
          "360-Grad-Ansichten",
        ],
        social: [
          "Produktmerkmale",
          "Kundenbewertungen",
          "Sonderaktionen",
          "Anleitungen",
        ],
        print: [
          "Produktkataloge",
          "Verpackungsdesign",
          "Beilagekarten",
          "Werbematerialien",
        ],
        website: [
          "E-Commerce-Plattform",
          "Produktseiten",
          "Warenkorb",
          "Kundenbewertungen",
        ],
      },
    },
  },
  ro: {
    services: {
      video: "Producție video",
      photography: "Fotografie",
      social: "Conținut social media",
      print: "Materiale print",
      website: "Soluții website",
    },
    industries: {
      restaurants: {
        title: "Restaurante și cafenele",
        video: [
          "Videoclipuri cu preparate",
          "Testimoniale clienți",
          "Videoclipuri de ambianță",
          "Interviuri cu bucătari",
          "Tururi behind-the-scenes în bucătărie",
          "Spotlight pe preparate din meniu",
          "Videoclipuri tip rețetă",
        ],
        photography: [
          "Fotografie culinară de calitate",
          "Fotografii interior/exterior",
          "Fotografii echipă",
          "Fotografie evenimente",
        ],
        social: [
          "Postări cu imagini apetisante",
          "Oferte zilnice",
          "Concursuri pentru clienți",
          "Colaborări cu influenceri",
        ],
        print: [
          "Meniuri",
          "Flyere",
          "Display-uri de masă",
          "Carduri de fidelitate",
          "Cărți de vizită",
        ],
        website: [
          "Sistem de comenzi online",
          "Rezervări",
          "Parteneriate livrare mâncare",
        ],
      },
      retail: {
        title: "Magazine retail",
        video: [
          "Demonstrații produse",
          "Testimoniale clienți",
          "Videoclipuri unboxing",
          "Tururi în magazin",
          "Promoții sezoniere",
          "Colaborări cu influenceri",
        ],
        photography: [
          "Fotografie produse de calitate",
          "Fotografii lifestyle",
          "Fotografii interior/exterior magazin",
          "Fotografii cu modele",
        ],
        social: [
          "Lansări de produse",
          "Anunțuri de reduceri",
          "Behind-the-scenes",
          "Spotlight clienți",
          "Marketing cu influenceri",
        ],
        print: [
          "Broșuri",
          "Flyere",
          "Vitrine",
          "Semnalistică în magazin",
          "Etichete de preț",
          "Cărți de vizită",
        ],
        website: [
          "Platformă e-commerce",
          "Cataloage online",
          "Recenzii clienți",
        ],
      },
      salons: {
        title: "Saloane și spa-uri",
        video: [
          "Demonstrații tratamente",
          "Testimoniale clienți",
          "Tururi spa",
          "Transformări înainte/după",
          "Prezentări echipă",
        ],
        photography: [
          "Imagini de calitate cu servicii",
          "Fotografii echipă",
          "Ambianță spa",
          "Portrete clienți",
        ],
        social: [
          "Oferte tratamente",
          "Promoții",
          "Spotlight echipă",
          "Transformări clienți",
        ],
        print: [
          "Meniuri servicii",
          "Vouchere cadou",
          "Cărți de vizită",
          "Materiale promoționale",
        ],
        website: [
          "Programări online",
          "Descrieri servicii",
          "Profiluri echipă",
        ],
      },
      fitness: {
        title: "Centre fitness și săli de sport",
        video: [
          "Tutoriale antrenament",
          "Povești de succes ale membrilor",
          "Tururi facilități",
          "Previzualizări cursuri",
          "Prezentări antrenori",
        ],
        photography: [
          "Fotografii facilități",
          "Cadre din timpul cursurilor",
          "Demonstrații echipamente",
          "Transformări membri",
        ],
        social: [
          "Sfaturi antrenament",
          "Sfaturi nutriție",
          "Spotlight membri",
          "Programe cursuri",
          "Evenimente speciale",
        ],
        print: [
          "Programe cursuri",
          "Broșuri abonamente",
          "Cărți de vizită",
          "Flyere promoționale",
        ],
        website: [
          "Sistem rezervări cursuri",
          "Opțiuni abonament",
          "Profiluri antrenori",
        ],
      },
      realestate: {
        title: "Agenții imobiliare",
        video: [
          "Tururi proprietăți",
          "Ghiduri de zonă",
          "Prezentări agenți",
          "Testimoniale clienți",
          "Actualizări piață",
        ],
        photography: [
          "Fotografii profesionale proprietăți",
          "Fotografie aeriană",
          "Portrete agenți",
          "Imagini din comunitate",
        ],
        social: [
          "Anunțuri proprietăți",
          "Anunțuri open house",
          "Insight-uri piață",
          "Povești de succes clienți",
        ],
        print: [
          "Broșuri proprietăți",
          "Cărți de vizită",
          "Materiale direct mail",
          "Flyere proprietăți",
        ],
        website: [
          "Listări proprietăți",
          "Tururi virtuale",
          "Profiluri agenți",
          "Testimoniale clienți",
        ],
      },
      professional: {
        title: "Servicii profesionale",
        video: [
          "Testimoniale clienți",
          "Explicații servicii",
          "Videoclipuri cultură companie",
          "Interviuri experți",
          "Demonstrații proces",
        ],
        photography: [
          "Portrete profesionale",
          "Mediul de birou",
          "Fotografii echipă",
          "Acoperire evenimente",
        ],
        social: [
          "Insight-uri din industrie",
          "Actualizări companie",
          "Spotlight echipă",
          "Povești de succes clienți",
        ],
        print: [
          "Broșuri servicii",
          "Cărți de vizită",
          "Mape prezentare",
          "Documente studii de caz",
        ],
        website: [
          "Descrieri servicii",
          "Profiluri echipă",
          "Portal clienți",
          "Studii de caz",
        ],
      },
      homeservices: {
        title: "Servicii pentru casă",
        video: [
          "Demonstrații servicii",
          "Testimoniale clienți",
          "Transformări înainte/după",
          "Prezentări echipă",
          "Proceduri de siguranță",
        ],
        photography: [
          "Fotografii înainte/după",
          "Fotografii echipă",
          "Echipamente/unelte",
          "Cadre din procesul de lucru",
        ],
        social: [
          "Sfaturi întreținere",
          "Servicii sezoniere",
          "Recenzii clienți",
          "Oferte speciale",
        ],
        print: [
          "Broșuri servicii",
          "Cărți de vizită",
          "Formulare estimări",
          "Materiale door hanger",
        ],
        website: [
          "Descrieri servicii",
          "Programări online",
          "Zone deservite",
          "Servicii de urgență",
        ],
      },
      ecommerce: {
        title: "Afaceri e-commerce",
        video: [
          "Demonstrații produse",
          "Experiențe unboxing",
          "Testimoniale clienți",
          "Behind-the-scenes",
          "Lansări de produse",
        ],
        photography: [
          "Fotografie produse",
          "Fotografii lifestyle",
          "Ambalaj/unboxing",
          "Vederi 360°",
        ],
        social: [
          "Caracteristici produse",
          "Recenzii clienți",
          "Promoții speciale",
          "Ghiduri how-to",
        ],
        print: [
          "Cataloage produse",
          "Design ambalaje",
          "Carduri incluse în pachet",
          "Materiale promoționale",
        ],
        website: [
          "Platformă e-commerce",
          "Pagini produse",
          "Coș de cumpărături",
          "Recenzii clienți",
        ],
      },
    },
  },
};

export function getIndustryData(language = "en") {
  const translations =
    industryTranslations[language] || industryTranslations.en;

  return Object.entries(translations.industries).reduce(
    (acc, [key, industry]) => {
      acc[key] = {
        title: industry.title,
        services: Object.entries(translations.services).reduce(
          (services, [serviceKey, serviceTitle]) => {
            services[serviceKey] = {
              title: serviceTitle,
              items: industry[serviceKey] || [], // Get items directly from the industry
            };
            return services;
          },
          {}
        ),
      };
      return acc;
    },
    {}
  );
}
